import _ from "lodash";
import {
  Component,
} from "react";
import {
  withLocation,
} from "CommonCore/router-util";
import {
  Button,
  Dropdown,
} from "react-bootstrap";

import {
  Awesome,
} from "CommonComponents/bricks";

const updateOnOpenModifier = {
  name: "updateOnOpen",
  enabled: true,
  phase: "write",
  fn: _.noop,
  effect: ({
    instance,
  }) => {
    if (typeof window === "undefined") {
      return undefined;
    }

    const rafId = window.requestAnimationFrame(() => {
      instance.update();
    });

    return () => window.cancelAnimationFrame(rafId);
  },
};

@withLocation
export default class ActionsDropdown extends Component {
  constructor() {
    super();
    this.state = {
      popperReady: false,
    };
    this.popperReadyRaf = null;
  }

  render() {
    let { actions } = this.props;
    const { id, item } = this.props;
    if (_.isFunction(actions)) {
      actions = actions(item);
    }

    const ActionComponent = this.state && this.state.actionToRender && this.state.actionToRender.component;

    if (_.isArray(actions)) {
      if (_.isEmpty(actions)) {
        // Übergabe eines leeren Arrays verbirgt das DropDown
        return null;
      }

      actions = this.normalizeActions(actions);
      if (actions.length === 1) {
        actions = actions[0];
      }
    }

    if (_.isArray(actions)) {
      const visibleActions = this.normalizeActions(
        actions.filter(action => action.visible === undefined || action.visible(item)),
      );
      const menuClassName = `actions-dropdown-menu${ this.state.popperReady ? " actions-dropdown-menu-ready" : "" }`;

      return <Dropdown
        id={id}
        className='float-end'
        align='end'
        onSelect={eventKey => this.executeAction(item, visibleActions[eventKey])}>
        <Dropdown.Toggle
          variant={this.props.style || "info"}
          id={id}>
          Aktionen
        </Dropdown.Toggle>
        <Dropdown.Menu
          className={menuClassName}
          popperConfig={{
            strategy: "fixed",
            onFirstUpdate: this.onMenuFirstUpdate,
            modifiers: [{
              name: "preventOverflow",
              options: {
                boundary: "viewport",
                altAxis: true,
              },
            }, {
              name: "offset",
              options: {
                offset: [0, 4],
              },
            }, updateOnOpenModifier],
          }}>
          {
            visibleActions.map((action, i) => action.divider
              ? <Dropdown.Divider key={i} />
              : <Dropdown.Item
                eventKey={i.toString()}
                disabled={action.disabled && action.disabled(item)}
                key={i}>
                {action.icon && <Awesome name={action.icon} />}
                {action.display}
              </Dropdown.Item>)
          }
        </Dropdown.Menu>
        {ActionComponent && <ActionComponent onClose={this.clearActionToRender} item={this.state.actionItem} />}
      </Dropdown>;
    }
    const action = actions;
    return <span><Button variant={this.props.style || "info"} onClick={() => this.executeAction(item, action)}>{action.display}</Button>
      {ActionComponent && <ActionComponent onClose={this.clearActionToRender} item={this.state.actionItem} />}</span>;
  }

  normalizeActions = actions => {
    let normalized = actions.filter(x => x);
    normalized = _.dropRightWhile(normalized, action => action.divider);
    normalized = _.reject(normalized, (action, i) => (i === 0 || normalized[i - 1].divider) && action.divider);
    return normalized;
  };

  clearActionToRender = () => {
    this.setState({ actionToRender: undefined }, () => {
      const result = _.isFunction(this.state.executeAfter) ? this.state.executeAfter(this.state.actionItem, this.props) : this.state.executeAfter;
      if (_.isString(result)) {
        this.props.history.push(result);
      }
    });
  };

  componentWillUnmount() {
    if (this.popperReadyRaf) {
      window.cancelAnimationFrame(this.popperReadyRaf);
      this.popperReadyRaf = null;
    }
  }

  onMenuFirstUpdate = () => {
    if (this.state.popperReady) {
      return;
    }
    if (typeof window === "undefined") {
      this.setState({ popperReady: true });
      return;
    }

    this.popperReadyRaf = window.requestAnimationFrame(() => {
      this.popperReadyRaf = null;
      this.setState({ popperReady: true });
    });
  };

  executeAction(item, action) {
    if (action.component) {
      // Action möchte eine Component rendern lassen
      this.setState({ actionToRender: action, actionItem: item, executeAfter: action.executeAfter });
    } else {
      const result = _.isFunction(action.execute) ? action.execute(item, this.props) : action.execute;
      if (_.isString(result)) {
        this.props.history.push(result);
      }
    }
  }
}
